import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var LinkedinIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M20.52 2H3.476C2.662 2 2 2.646 2 3.441v17.116C2 21.353 2.662 22 3.476 22H20.52c.816 0 1.48-.647 1.48-1.443V3.44C22 2.646 21.335 2 20.52 2zM6.45 4.754a1.72 1.72 0 11-.004 3.44 1.72 1.72 0 01.003-3.44zM4.964 19.043h2.967V9.498H4.965v9.545zm4.827-9.545h2.845v1.304h.04c.396-.75 1.364-1.541 2.807-1.541 3.004 0 3.558 1.977 3.558 4.546v5.236h-2.964V14.4c0-1.107-.02-2.53-1.541-2.53-1.544 0-1.781 1.205-1.781 2.45v4.722H9.792V9.498z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
LinkedinIcon.isCarinaIcon = true;
export default LinkedinIcon;
